import type { ReactNode } from 'react';
import {
  Body, Card, Eyebrow, Heading, I, Icon, Row, Stack, TONE, type Tone, } from '@leanin/ui';

export function AttachmentCard({
  src, tone = 'yellow', icon, kind, title, meta,
}: {
  src?: string;
  tone?: Tone;
  icon?: ReactNode;
  kind?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
}) {
  return (
    <Card pad="flush" style={{ overflow: 'hidden' }}>
      <Row gap="none" align="stretch">
        <div style={{
          width: src ? 160 : 96,
          flexShrink: 0,
          minHeight: 88,
          background: src ? `url(${src}) center/cover` : TONE[tone].bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {!src && <Icon size="lg" color={TONE[tone].ink}>{icon ?? I.book}</Icon>}
        </div>
        <Stack gap="xs" p="lg" style={{ flex: 1, justifyContent: 'center' }}>
          {kind && <Eyebrow>{kind}</Eyebrow>}
          <Heading level={5}>{title}</Heading>
          {meta && <Body size="sm" color="mute">{meta}</Body>}
        </Stack>
      </Row>
    </Card>
  );
}
